var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isEnable)?_c('div',{staticClass:"paralax"},[_c('object',{attrs:{"data":[_vm.bean.urlData, _vm.bean.interfaceData.path, _vm.paralax.image + ".svg"].join("/")},on:{"load":_vm.loadSvg}}),_c('theme-menu',{attrs:{"data":_vm.bean.interfaceData,"icon":_vm.next.icon,"hourToForce":_vm.next.startHour}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }